import { useStores } from 'stores/utils/hooks/useStores'
import { isTenantSmava } from 'utils/url'
import { useGate } from 'gates'
import { VoucherBannerVariant } from '../VoucherBanner.types'
import {
  resolveLegacySmavaVoucherAmount,
  resolveTieredVoucherAmount,
  resolveVarBSmavaVoucherAmount
} from '../helpers/voucherAmount'

export const getVoucherAmount = (
  loanAmount: number,
  variant: VoucherBannerVariant
): number | null => {
  return variant === 'smava'
    ? resolveLegacySmavaVoucherAmount(loanAmount)
    : resolveTieredVoucherAmount(loanAmount)
}

const useVoucherAmount = (): number | null => {
  const { traversal } = useStores()
  const variant: VoucherBannerVariant = isTenantSmava() ? 'smava' : 'ffg'
  const isSmavaHigherAmountActive = useGate('cat4707SmavaVoucherVarB')

  if (isSmavaHigherAmountActive) {
    return resolveVarBSmavaVoucherAmount(traversal.data.common.amount)
  }
  return getVoucherAmount(traversal.data.common.amount, variant)
}

export default useVoucherAmount
